import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  widgetsContent: {
    maxWidth: '550px',
    width: '29.5vw',
    minWidth: '392px',
    maxHeight: '98vh',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: theme.shape.scrollSize,
      height: theme.shape.scrollSize,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.scroll,
      borderRadius: theme.shape.scrollRadius,
    },
    borderRadius:theme.shape.borderRadius,
    boxShadow: theme.shadows[3],
    paddingRight: '3px',
  },
}))

export default useStyles
